import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";import Safety from "@/pages/Safety";
import HowItWorks from "@/pages/HowItWorks";
import Pricing from "@/pages/Pricing";
import MembershipBenefits from "@/pages/MembershipBenefits";
import Book from "@/pages/Book";
import ServiceAreas from "@/pages/ServiceAreas";
import CityDetail from "@/pages/CityDetail";
import Apply from "@/pages/Apply";
import About from "@/pages/About";
import Faqs from "@/pages/Faqs";
import Contact from "@/pages/Contact";
import Reviews from "@/pages/Reviews";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/services" element={withLayout(<Services />)} />
          <Route path="/services/:serviceId" element={withLayout(<ServiceDetail />)} />
          <Route path="/safety-screening" element={withLayout(<Safety />)} />
          <Route path="/how-it-works" element={withLayout(<HowItWorks />)} />
          <Route path="/pricing" element={withLayout(<Pricing />)} />
          <Route path="/pricing/benefits" element={withLayout(<MembershipBenefits />)} />
          <Route path="/book" element={withLayout(<Book />)} />
          <Route path="/service-areas" element={withLayout(<ServiceAreas />)} />
          <Route path="/service-areas/:cityId" element={withLayout(<CityDetail />)} />
          <Route path="/apply" element={withLayout(<Apply />)} />
          <Route path="/careers" element={withLayout(<Apply />)} />
          <Route path="/about" element={withLayout(<About />)} />
          <Route path="/faqs" element={withLayout(<Faqs />)} />
          <Route path="/contact" element={withLayout(<Contact />)} />
          <Route path="/reviews" element={withLayout(<Reviews />)} />
          <Route path="/privacy" element={withLayout(<Legal type="privacy" />)} />
          <Route path="/terms" element={withLayout(<Legal type="terms" />)} />
          <Route path="/accessibility" element={withLayout(<Legal type="accessibility" />)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
